import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUIFilterablePaginatedSectionCategoryNavigationNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/CategoryNavigation/SDUIFilterablePaginatedSectionCategoryNavigationNonRSC";
import { FilterablePaginatedSectionFiltersNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/FilterablePaginatedSectionFiltersNonRSC";
import { sideBarWrapper } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import React from "react";
export var FilterablePaginatedSectionSideBarRendererNonRSC = function(param) {
    var filterablePaginatedSection = param.filterablePaginatedSection, sectionLoggingData = param.sectionLoggingData;
    return /*#__PURE__*/ _jsxs("div", {
        className: sideBarWrapper,
        children: [
            /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionCategoryNavigationNonRSC, {
                filterablePaginatedSection: filterablePaginatedSection
            }),
            /*#__PURE__*/ _jsx(FilterablePaginatedSectionFiltersNonRSC, {
                filterablePaginatedSection: filterablePaginatedSection,
                sectionLoggingData: sectionLoggingData
            })
        ]
    });
};
